export const columns1 = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '姓名',
    dataIndex: 'user_nickname',
  },
  {
    title: '性别',
    dataIndex: 'user_realname',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index) => {
      return record.status === 0 ? '禁用' : '启用';
    }
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columns2 = [
  {
    title: '编号',
    dataIndex: 'id',
    width: '5%'
  },
  {
    title: '真实姓名',
    dataIndex: 'user_realname',
  },
  {
    title: '性别',
    dataIndex: 'sex',
    customRender: (text, record, index) => {
      if (record.sex === 1) {
        return '男';
      } else if (record.sex === 2) {
        return '女';
      } else {
        return '保密';
      }
    },
  },
  {
    title: '身份证号',
    dataIndex: 'id_card',
  },
  {
    title: '班级',
    dataIndex: 'grade',
  },
  {
    title: '登录次数',
    dataIndex: 'login_count',
    align: 'center',
    scopedSlots: { customRender: 'login_count' },
  },
  {
    title: '练习次数',
    dataIndex: 'exercisesTimes',
    align: 'center',
    scopedSlots: { customRender: 'exercisesTimes' },
  },
  {
    title: '练习错题数',
    dataIndex: 'errorExercisesTimes',
    align: 'center',
    scopedSlots: { customRender: 'errorExercisesTimes' },
  },
  {
    title: '模拟次数',
    dataIndex: 'randomTimes',
    align: 'center',
    scopedSlots: { customRender: 'randomTimes' },
  },
  {
    title: '模拟错题数',
    dataIndex: 'errorRandomTimes',
    align: 'center',
    scopedSlots: { customRender: 'errorRandomTimes' },
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index) => {
      return record.status === 0 ? '禁用' : '启用';
    },
  },
  {
    title: '添加时间',
    dataIndex: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const columns3 = [
  {
    title: 'Excel行号',
    dataIndex: 'line',
    //  align:'center',
    width: '6%'
  },
  {
    title: '姓名',
    dataIndex: 'user_realname',
    width: '6%'
  },
  {
    title: '学号',
    dataIndex: 'student_number',
    width: '10%'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    width: '5%'
  },
  {
    title: '身份证件号',
    dataIndex: 'id_card',
    width: '15%'
  },
  {
    title: '院系',
    dataIndex: 'department',
    width: '10%'
  },
  {
    title: '专业',
    dataIndex: 'specialty',
    width: '12%'
  },
  {
    title: '班级',
    dataIndex: 'grade',
    width: '12%'
  },
  {
    title: '反馈信息',
    dataIndex: 'error_msg',
    scopedSlots: { customRender: 'error_msg' },
    width: '20%'
  },
];
export const formData = [
  {
    name: 'sex',
    lable: '状态',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'user_nickname',
    lable: '学员姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'sex',
    lable: '性别',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'mobile',
    lable: '手机号',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'introduction',
    lable: '注册时间',
    lableCol: 4,
    wrapperCol: 18,
  },
];

export const allotBusinessColumns = [
  {
    name: 'user_realname',
    lable: '推广人姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'allot_buesness',
    lable: '分配客户',
    lableCol: 4,
    wrapperCol: 18,
    class: 'allot_buesness'
  },
];

export const showLoginListColumns = [
  {
    name: 'id',
    title: '序号',
    width: '80px',
    align: 'center',
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    name: 'login_time',
    title: '登录日期',
    customRender: (text, record, index) => record.login_time
  },
  {
    name: 'login_ip',
    title: '登录IP',
    customRender: (text, record, index) => record.login_ip
  },
];

export const showQuestionColumns = [
  {
    dataIndex: 'id',
    title: '序号',
    width: '60px',
    align: 'center',
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    dataIndex: 'title',
    title: '考试等级',
  },
  {
    dataIndex: 'is_submit',
    title: '试卷状态',
    width: '90px',
    scopedSlots: { customRender: 'is_submit' },
  },
  {
    dataIndex: 'question_total',
    title: '题量',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'answer_total',
    title: '已作答',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'will_answer',
    title: '待作答',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'right_num',
    title: '正确数',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'right_rate',
    title: '正确率',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'errors_num',
    title: '错误数',
    align: 'center',
    width: '80px',
  },
  {
    dataIndex: 'errors_rate',
    title: '错误率',
    align: 'center',
    width: '80px',
  },
  {
    title: '练习时间',
    dataIndex: 'create_time_txt',
    width: '165px',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '60px',
  },
];